import { useEffect, useRef, useState, useCallback } from "react";
import images from "../../assets/images";
import "./InAppDownloads.scss";
import ImageViewer from "../../components/ImageViewer/ImageViewer";
import PDFViewer from "../../components/PDFViewer/PDFViewer";
import FileViewer from "../../components/FileViewer/FileViewer";
import CsvViewer from "../../components/CsvViewer/CsvViewer";
import EpubFileViewer from "../../components/EpubFileViewer/EpubFileViewer";
import SingleAudioPlay from "../../components/SingleAudioPlay/SingleAudioPlay";
import VideoViewer from "../../components/VideoViewer/VideoViewer";
import { useLocation } from "react-router-dom";
import ConfirmationPopup from "../../components/ConfirmationPopup/ConfirmationPopup";
import Loader from "../../components/Loader/Loader";
import { useAppSelector } from "../../redux/app/hooks";
import ToasterWithMessage from "../../components/toaster";
import { formatFileSize } from "../../utils/helper";
import moment from "moment";
import { MYLIBRARY_TEXTS } from "../../utils/constants";

interface ElectronFileDetail {
  id:string;
  fileId: string;
  userId: string;
  filename: string;
  filetype?: string;
  filepath: string;
  filesize: number;
  filedata: Buffer | Blob; // Assuming filedata can be a Buffer or Blob
  fileLocation?: string;
  subject?: string;
  timestamp: string;
}

const fileTypeMap: { [key: string]: string } = {
  pdf: "PDF Document",
  xlsx: "Microsoft Excel Document",
  xls: "Microsoft Excel Document",
  csv: "CSV Document",
  epub: "EPUB",
  doc: "Microsoft Word Document",
  docx: "Microsoft Word Document",
  ppt: "Microsoft PowerPoint Document",
  pptx: "Microsoft PowerPoint Document",
  jpg: "JPEG Image",
  jpeg: "JPEG Image",
  png: "PNG Image",
  svg: "SVG Document",
  mp3: "MP3 Audio",
  wav: "WAV Audio",
  ogg: "OGG Audio",
  mp4: "MP4 Video",
  avi: "AVI Video",
};

const InAppDownloads = () => {
const {
    pdfImg,
    DeleteGif,
    csvImg,
    docsImg,
    excelPreview,
    powerpoint,
    epub,
    backArrow,
    imageSvg,
    videoPlay,
    audioSvg
  } = images;

  const [fileDetails, setFileDetails] = useState<ElectronFileDetail[]>([]);
  const [displayView, setDisplayView] = useState<boolean>(false);
  const [fileContent, setFileContent] = useState<string>('');
  const [selectedFile, setSelectedFile] = useState<ElectronFileDetail | null>(null);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [totalFiles, setTotalFiles] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const profile = useAppSelector((state) => state.auth.adminProfile);
  const {error, success} = ToasterWithMessage();
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  
    const fileTypeIcons: { [key: string]: string } = {
        pdf: pdfImg,
        csv: csvImg,
        doc: docsImg,
        docs: docsImg,
        docx: docsImg,
        xls: excelPreview,
        xlsx: excelPreview,
        ppt: powerpoint,
        pptx: powerpoint,
        epub: epub,
        image: imageSvg,
        png: imageSvg,
        video: videoPlay,
        mp4: videoPlay,
        audio: audioSvg,
        mp3: audioSvg
      };

      const formatTimestamp = (timestamp: any) => {

        const localDate = moment.utc(timestamp).local();  // Convert from UTC to local timezone
    
        // Format the date in the desired format
        const day = localDate.format('DD');
        const month = localDate.format('MMM');  // Short month name
        const year = localDate.format('YYYY');
        const time = localDate.format('h:mm A');  // 12-hour time with AM/PM

        return `${day}-${month}-${year} at ${time}`;
    };

    // Function to extract file extension from filepath
const getFileExtension = (filepath: string): string => {
  if (!filepath) {
    return ''; // Return empty if no filepath
  }

  const parts = filepath.split('.');
  return parts.length > 1 ? parts.pop()?.toLowerCase() || '' : ''; // Return the extension in lowercase
};

  // Pagination state
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(10);  // Fixed items per page
  const totalPages = Math.ceil(totalFiles / itemsPerPage);

  // Fetch materials and total count with pagination
  const getInAppDownloadsList = useCallback((page: number = 1, limit: number = 10) => {
    try {
      setIsLoading(true);  // Start loading
      if (window.electron && window.electron.isElectron()) {
        if(profile?.getCurrentUser?.nodes[0]?.uId){
           window?.electron?.getMaterials( page, limit, profile?.getCurrentUser?.nodes[0]?.uId);
        }else{
          error('user details was not provided properly');
        }
      }else{
        error('Platform not supported')
      }
    } catch (err) {
      setIsLoading(false);  // Stop loading in case of an error
      console.error('Error fetching materials:', err);
    }
  }, []);

  // Handle the response for fetched materials
  useEffect(() => {
    const handleGetMaterialsResponse = (response: any) => {
      if (response.success) {
        console.log('[handleGetMaterialsResponse] current page', currentPage);
        console.log('[handleGetMaterialsResponse] response', response.materials);

        setFileDetails(response.materials);  // Always replace with new data
        setTotalFiles(response.total);
      } else {
        console.error('Error fetching materials:', response.error);
      }
      setIsLoading(false);  // Stop loading after response
    };

    // Subscribe to the event listener
    if (window.electron && window.electron.isElectron()) {
      window.electron.on('get-materials-response', handleGetMaterialsResponse);
    }

    // Cleanup event listener on unmount
    return () => {
      if (window.electron && window.electron.isElectron()) {
      window.electron.removeListener('get-materials-response', handleGetMaterialsResponse);
      }
    };
  }, []);

// Fetch the current page data when page number changes
useEffect(() => {
    console.log("[useEffect] currentPage:", currentPage);  // Debug log
    if (currentPage > 0) {
      getInAppDownloadsList(currentPage, itemsPerPage); // Only fetch current page
    }
  }, [currentPage, getInAppDownloadsList, itemsPerPage]);
  

  const handleFileClick = (file: ElectronFileDetail) => {
    console.log('filedata inside the click =======>',file.filedata);
    const fileDataBlob = new Blob([file.filedata], { type: file.filetype });
    const fileBlobUrl = URL.createObjectURL(fileDataBlob);
    console.log('fileblob url=======>',fileBlobUrl);
    setFileContent(fileBlobUrl);
    setSelectedFile(file);
    setDisplayView(true);
  };

  const handleCloseViewer = () => {
    setDisplayView(false);
    setFileContent('');
    setSelectedFile(null);
  };

  const [showNameTooltip, setShowNameTooltip] = useState<boolean[]>([]);
  const [showCategoryTooltip, setShowCategoryTooltip] = useState<boolean[]>([]);
  const columnRefs = useRef<(HTMLTableCellElement | null)[]>([]);

  // Function to detect if a column is overflowing
  const checkOverflow = (index: number): boolean => {
    const element = columnRefs.current[index];
    if (element) {
      return element.scrollWidth > element.clientWidth;
    }
    return false;
  };

  const updateTooltips = useCallback(() => {
    const nameTooltips = fileDetails.map((_, rowIndex) =>
      checkOverflow(rowIndex * 7)
    ); // Name column index is 0
    const categoryTooltips = fileDetails.map((_, rowIndex) =>
      checkOverflow(rowIndex * 7 + 4)
    ); // Category column index is 4

    setShowNameTooltip(nameTooltips);
    setShowCategoryTooltip(categoryTooltips);
  }, [fileDetails]);

  // On mount and on fileDetails change, check for text overflow
  useEffect(() => {
    updateTooltips();
  }, [updateTooltips]); // Use updateTooltips as a dependency

  // Add event listener for window resize and update tooltips on resize
  useEffect(() => {
    const handleResize = () => {
      updateTooltips();
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [updateTooltips]);

  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalFiles / itemsPerPage) && !isLoading) {
      console.log("Next page clicked, currentPage:", currentPage + 1);  // Debug log
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };
  
  const handlePrevPage = () => {
    if (currentPage > 1 && !isLoading) {
      console.log("Previous page clicked, currentPage:", currentPage - 1);  // Debug log
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  

  const deleteFile = async (data: ElectronFileDetail) => {
    console.log('inside the handle delete');
    try {
      if (window.electron && window.electron.isElectron()) {
        const { id } = data;
        const userid = profile?.getCurrentUser?.nodes[0]?.uId
        if (id && userid) {
          const response = await window.electron.deleteMaterial(id, userid);
          if (response.success) {
            console.log(`Material with fileId: ${id} deleted successfully.`);
            success('File deleted successfully');
            if(fileDetails.length === 1 && currentPage > 1){
              setCurrentPage(currentPage -1);
            await getInAppDownloadsList(currentPage-1, itemsPerPage);
            }else{
              await getInAppDownloadsList(currentPage, itemsPerPage);
            }
            
          } else {
            console.error('Failed to delete material:', response.message);
          }
        } else {
          error('Datas are missing. Please try again')
        }
      } else {
        console.warn('Platform not supported');
      }
    } catch (err) {
      console.error('Error invoking delete-material:', err);
    }
  };

  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    console.log('selectedfile===>',selectedFile);
    if (selectedFile){
      deleteFile(selectedFile);
    }
  };

  const onNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  };

  const renderViewer = () => {
    if (!selectedFile) {
      return null;
    }

        // Rendering logic for different file types
        switch (selectedFile.filetype) {
            case 'video':
            case 'mp4':
                return (
                    // <video
                    //     src={fileContent}
                    //     ref={videoRef}
                    //     autoPlay
                    //     disablePictureInPicture
                    //     controls
                    //     controlsList='nodownload noplaybackrate'
                    //     loop
                    //     className='detailVideoTagStyle'
                    //     style={{ display: 'flex', outline: 'none', border: 'none' }}
                    // />
                  <VideoViewer
                    video={fileContent}
                    onClose={handleCloseViewer}
                    type={MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT}
                    videoRef={videoRef}
                    // videoId = {clickedVideoData?.rsId ? clickedVideoData?.rsId : ''}
                    videoData={selectedFile}
                  />
                );
            case 'audio':
            case 'mp3':
                return <SingleAudioPlay podCastPDFFilePath={fileContent} />;
            case 'image':
            case 'png':
                return <ImageViewer file={fileContent} onClose={handleCloseViewer} imgFileData={selectedFile} type={MYLIBRARY_TEXTS?.IMAGES_TEXT} />;
            case 'epub':
                return <EpubFileViewer fileUrl={fileContent} fileData={selectedFile} />;
            case 'pdf':
            case 'docs':
            case 'doc':
            case 'docx':
            case 'ppt':
            case 'pptx':
                return <PDFViewer file={fileContent} pdfFileData={selectedFile} onClose={handleCloseViewer} type="Teaching Material" />;
            case 'csv':
                if(getFileExtension(selectedFile?.filepath) === 'csv'){
                  return <CsvViewer fileUrl={fileContent} fileData={selectedFile} onClose={handleCloseViewer} />;
                }else{
                  return (
                    <FileViewer
                        fileUrl={fileContent}
                        fileData={selectedFile}
                        onClose={handleCloseViewer}
                        fileType={'excel'}
                    />
                  );
                }
            case 'excel':
            case 'xls':
            case 'xlsx':
                return (
                    <FileViewer
                        fileUrl={baseUrl+selectedFile?.filepath}
                        fileData={selectedFile}
                        onClose={handleCloseViewer}
                        fileType={'excel'}
                    />
                );
            default:
                return null;
        }
    };

  return (
    <div
      className={`${
        fileDetails.length > 0 ? (selectedFile && (selectedFile?.filetype === 'excel' ||selectedFile?.filetype === 'csv')) ? "csvdownloadsListContainer" : "downloadsListContainer" : "noData"
      }`}
      style={{ padding: "20px", gap: '40px' }}
    >
      {isLoading ? <Loader />
      : displayView && selectedFile ? (
        <div className="ElectronviewContainer">
          <div className="viewHeader">
            <img
              src={backArrow}
              onClick={handleCloseViewer}
              alt="backArrow"
              className="backIcon"
            />
          </div>
          <div className={selectedFile?.filetype === 'video' || selectedFile?.filetype === 'excel' ||selectedFile?.filetype === 'csv' ? "viewerContainerColumn" :"viewerContainer"}>
          {renderViewer()}
          </div>
        </div>
      ) : fileDetails.length > 0 ? (
        <div className="downloads-table-container">
          <table className="downloads-table">
            <thead>
              <tr>
                <th className="name-column-heading">Name</th>
                <th className="date-modified-column">Date</th>
                <th className="type-column">Type</th>
                <th className="size-column">Size</th>
                <th className="category-column">Category</th>
                <th className="subject-column">Subject</th>
                <th className="actions-column"></th>
              </tr>
            </thead>
            <tbody className="table-body">
              {fileDetails.map((file, index) => (
                <tr key={index} className="downloads-row">
                  <td
                    className="name-column"
                    onClick={() => handleFileClick(file)}
                  >
                    {fileTypeIcons[file.filetype === "csv" ? getFileExtension(file?.filepath) : (file.filetype?.toLowerCase() || file.filepath.split('.').pop()?.toLowerCase() || '')] && (
                       <img
                       src={fileTypeIcons[file.filetype === "csv" ? getFileExtension(file?.filepath) : (file.filetype?.toLowerCase() || file.filepath.split('.').pop()?.toLowerCase() || '')]}
                       alt={file.filetype}
                        className="file-icon"
                      />
                    )}
                    {file.filename ? file.filename : "-"}
                  </td>
                  <td className="date-modified-column">{file.timestamp ? formatTimestamp(file.timestamp):"-"}</td>
                  <td className="type-column">{file.filetype ? fileTypeMap[getFileExtension(file.filepath)]: '-'}</td>
                  <td className="size-column">{file.filesize ? formatFileSize(file.filesize):"-"}</td>
                  <td className="category-column">{file.fileLocation ? file.fileLocation : "-"}</td>
                  <td className="subject-column">{file.subject ? file.subject:"-"}</td>
                  <td className="actions-column">
                    <img
                      src={images.deleteIcon}
                      alt="deleteIcon"
                      className="deleteIcon"
                      onClick={() => {
                        setSelectedFile(file);
                        setOpenConfirmationPopup(true);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="noDataFoundStyle">No data found</div>
      )}
      {(!isLoading && fileDetails?.length > 0 && !displayView) && <div className="pagination">
            <button onClick={handlePrevPage} disabled={currentPage === 1} className={currentPage === 1 ? "disableprevBtn" : "prevBtn"}>
              Prev
            </button>
            <span className="currentPage">
              Page {currentPage} of {totalPages}
            </span>
            <button onClick={handleNextPage} disabled={currentPage >= totalPages} className={currentPage >= totalPages ? "disablenextBtn" : "nextBtn"}>
              Next
            </button>
          </div>}
      <ConfirmationPopup
        open={openConfirmationPopup}
        message={`Are you sure you want to delete this file?`}
        gifData={DeleteGif}
        yesButtonFunctionality={onYesButtonClick}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={"195px"}
      />
    </div>
  );
};

export default InAppDownloads;
